var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/*!\n * Toastify js 1.12.0\n * https://github.com/apvarun/toastify-js\n * @license MIT licensed\n *\n * Copyright (C) 2018 Varun A P\n */\n\n.toastify {\n  padding: 12px 20px;\n  color: #ffffff;\n  display: inline-block;\n  box-shadow: 0px 0px 25.185px 0px rgba(28, 0, 194, 0.05);\n  background: -webkit-linear-gradient(315deg, #73a5ff, #5477f5);\n  background: linear-gradient(135deg, #73a5ff, #5477f5);\n  position: fixed;\n  opacity: 0;\n  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\n  border-radius: 8px;\n  cursor: pointer;\n  text-decoration: none;\n  max-width: calc(50% - -80px);\n  z-index: 2147483647;\n}\n\n.toastify.on {\n  opacity: 1;\n}\n\n.toast-close {\n  background: transparent;\n  border: 0;\n  color: white;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 1em;\n  opacity: 0.4;\n  padding: 0 5px;\n}\n\n.toastify-right {\n  right: 15px;\n}\n\n.toastify-left {\n  left: 15px;\n}\n\n.toastify-top {\n  top: -150px;\n}\n\n.toastify-bottom {\n  bottom: -150px;\n}\n\n.toastify-rounded {\n  border-radius: 25px;\n}\n\n.toastify-avatar {\n  width: 1.5em;\n  height: 1.5em;\n  margin: -7px 5px;\n  border-radius: 2px;\n}\n\n.toastify-center {\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n  max-width: fit-content;\n  max-width: -moz-fit-content;\n}\n\n@media only screen and (max-width: 360px) {\n  .toastify-right,\n  .toastify-left {\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    max-width: fit-content;\n  }\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _eventBus = require("../eventBus");

var _toastifyJs = require("toastify-js");

var _toastifyJs2 = _interopRequireDefault(_toastifyJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "MobileMoney",
  props: {
    requestType: {
      type: String,
      required: true,
      default: ""
    },
    channels: {
      type: Array,
      required: true,
      default: []
    },
    baseUrl: {
      type: String,
      required: true,
      default: ""
    },
    invoice: {
      type: Object,
      default: {}
    },
    callback_url: {
      type: String,
      default: ""
    },
    status_api_url: {
      type: String,
      default: ""
    },
    telcos_prefixes: {
      type: Array,
      required: true,
      default: []
    },
    topupAmount: {
      type: Number,
      required: true,
      default: 0
    },
    variant: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      filteredCountries: [],
      countries: [],
      selectedCountry: null,
      phoneNumber: this.formatPhoneNumber(this.invoice.msisdn) || null,
      phoneInputFocused: false,
      dialCodeMenuOpen: false,
      selectedChannel: null,
      isLoading: false,
      currentStep: 1,
      getStatusRetryCount: 0,
      getStatusMaxRetries: 3,
      interValId: null,
      searchQuery: "",
      error: null,
      topupWalletMode: false,
      topupAndPay: false,
      currentAccount: null,
      ref_no: null,
      notification_url: null,
      customer_id: null,
      amount: 0,
      amountError: null
    };
  },
  created: function created() {
    var _this = this;

    _eventBus.eventBus.$on("topup-wallet-clicked", function (currentAccount, base_url, customerId) {
      _this.topupWalletMode = true;
      _this.currentAccount = currentAccount;
      _this.base_url = base_url;
      _this.customer_id = customerId;
    });

    _eventBus.eventBus.$on("topup-and-pay-wallet-clicked", function (currentAccount, notificationUrl, customerId, base_url, hidePayBtn) {
      _this.topupWalletMode = true;
      _this.currentAccount = currentAccount;
      _this.base_url = base_url;
      _this.notification_url = notificationUrl;
      _this.customer_id = customerId;
      _this.topupAndPay = true;
    });
  },

  computed: {
    selectedCountryDialCode: function selectedCountryDialCode() {
      return this.country.dial_code || null;
    },
    availableChannels: function availableChannels() {
      return this.channels.sort(function (a, b) {
        return a.id - b.id;
      });
    },
    country: function country() {
      if (this.selectedCountry == null) {
        return this.countries.find(function (elem) {
          return elem.code == "KE";
        });
      } else {
        return this.selectedCountry;
      }
    },
    errorMessage: function errorMessage() {
      return this.error;
    },
    amountErr: function amountErr() {
      return this.amountError;
    },
    exactTopUpAmount: function exactTopUpAmount() {
      if (this.topupAmount) {
        return this.topupAmount;
      } else {
        return this.invoice.amount_expected;
      }
    }
  },
  watch: {
    currentStep: function currentStep(value) {
      var _this2 = this;

      if (value === 2 && this.getStatusRetryCount < this.getStatusMaxRetries) {
        setTimeout(function () {
          _this2.confirmPayment();
        }, 1000);
      }
    },
    phoneNumber: function phoneNumber(value) {
      if (!this.validatePhoneNumberLength(value)) {
        return this.error = "Too short.";
      } else {
        switch (this.selectedChannel.label) {
          case "mpesa":
            if (!this.validateByChannelType("safaricom", value)) {
              return this.error = "Not a valid Safaricom phone number";
            } else {
              return this.error = "";
            }
          case "airtel":
            if (!this.validateByChannelType("airtel", value)) {
              return this.error = "Not a valid Airtel phone number";
            } else {
              return this.error = "";
            }
          case "tkash":
            if (!this.validateByChannelType("telkom", value)) {
              return this.error = "Not a valid Telkom phone number";
            } else {
              return this.error = "";
            }
          default:
            this.error = "";
        }
      }
    },
    getStatusRetryCount: function getStatusRetryCount(value) {
      if (value == this.getStatusMaxRetries) {
        clearInterval(this.interValId);
        this.currentStep = this.currentStep < 3 ? this.currentStep += 1 : this.currentStep;
        this.isLoading = false;
      }
    },
    searchQuery: function searchQuery(value) {
      if (value.length > 0) {
        this.filteredCountries = this.countries.filter(function (country) {
          return country.name.toLowerCase().includes(value.toLowerCase()) || country.code.toLowerCase() == value.toLowerCase() || country.dial_code.toLowerCase() == value.toLowerCase();
        });
      } else {
        this.filteredCountries = this.countries;
      }
    },
    error: function error(value) {
      this.errorMessage = value;
    },
    channels: {
      immediate: true,
      handler: function handler(newVal) {
        if (this.selectedChannel == null) {
          this.selectedChannel = this.channels.find(function (elem) {
            return elem.label == "mpesa";
          });
        }
      }
    },
    amount: function amount(value) {
      if (value < this.topupAmount) {
        this.amountError = "Top up amount cannot be less than " + this.topupAmount;
      } else {
        this.amountError = null;
      }
    }
  },
  mounted: function mounted() {
    if (this.invoice.amount_expected > 0) {
      var charges = this.selectedChannel && this.selectedChannel.configs && this.selectedChannel.configs.charges;

      var result = parseFloat(this.invoice.amount_expected) * (parseFloat(charges) / 100);

      var calculatedCardCharges = Math.round(result * 100) / 100;

      _eventBus.eventBus.$emit("gateway-fees-updated", calculatedCardCharges);

      this.topupAmount = this.invoice.amount_expected + calculatedCardCharges;
    }

    this.ref_no = this.invoice.invoice_number;
    this.fetchCountries();

    if (this.topupAmount) {
      this.amount = Math.ceil(this.topupAmount);
    }


    this.closeDialCodeMenu("dial-code-menu");
  },

  methods: {
    handleCancel: function handleCancel() {
      location.reload();
    },
    showToastr: function showToastr(type, title, subtitle) {
      var bgColor = void 0,
          icon = void 0;
      var color = "white";
      switch (type) {
        case "success":
          bgColor = "#4AC000";
          icon = "<svg viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.2499 10.5C19.2499 15.3325 15.3324 19.25 10.4999 19.25C5.66739 19.25 1.74988 15.3325 1.74988 10.5C1.74988 5.66751 5.66739 1.75 10.4999 1.75C15.3324 1.75 19.2499 5.66751 19.2499 10.5ZM14.0264 7.84846C14.2827 8.10474 14.2827 8.52026 14.0264 8.77654L9.65142 13.1515C9.39514 13.4078 8.97962 13.4078 8.72334 13.1515L6.97334 11.4015C6.71706 11.1453 6.71706 10.7297 6.97334 10.4735C7.22962 10.2172 7.64514 10.2172 7.90142 10.4735L9.18738 11.7594L11.1429 9.80394L13.0983 7.84846C13.3546 7.59218 13.7701 7.59218 14.0264 7.84846Z\" fill=\"white\"/>\n        </svg>";
          break;
        case "error":
          bgColor = "#E01A1A";
          icon = "<svg viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.2499 10.5C19.2499 5.66751 15.3324 1.75 10.4999 1.75C5.66739 1.75 1.74988 5.66751 1.74988 10.5C1.74988 15.3325 5.66739 19.25 10.4999 19.25C15.3324 19.25 19.2499 15.3325 19.2499 10.5ZM10.4999 5.46875C10.8623 5.46875 11.1561 5.76256 11.1561 6.125V11.375C11.1561 11.7374 10.8623 12.0313 10.4999 12.0313C10.1374 12.0313 9.84363 11.7374 9.84363 11.375V6.125C9.84363 5.76256 10.1374 5.46875 10.4999 5.46875ZM10.4999 14.875C10.9831 14.875 11.3749 14.4832 11.3749 14C11.3749 13.5168 10.9831 13.125 10.4999 13.125C10.0166 13.125 9.62488 13.5168 9.62488 14C9.62488 14.4832 10.0166 14.875 10.4999 14.875Z\" fill=\"white\"/>\n        </svg>";
          break;
        case "warning":
          bgColor = "#EF9300";
          icon = "<svg width=\"19\" height=\"19\" viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.2499 9.5C18.2499 14.3325 14.3324 18.25 9.49988 18.25C4.66739 18.25 0.749878 14.3325 0.749878 9.5C0.749878 4.66751 4.66739 0.75 9.49988 0.75C14.3324 0.75 18.2499 4.66751 18.2499 9.5ZM13.0264 6.84846C13.2827 7.10474 13.2827 7.52026 13.0264 7.77654L8.65142 12.1515C8.39514 12.4078 7.97962 12.4078 7.72334 12.1515L5.97334 10.4015C5.71706 10.1453 5.71706 9.72974 5.97334 9.47346C6.22962 9.21718 6.64514 9.21718 6.90142 9.47346L8.18738 10.7594L10.1429 8.80394L12.0983 6.84846C12.3546 6.59218 12.7701 6.59218 13.0264 6.84846Z\" fill=\"white\"/>\n        </svg>";
          break;
        case "info":
        default:
          bgColor = "#D6D6D6";
          icon = "<svg viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.2499 10.5C19.2499 15.3325 15.3324 19.25 10.4999 19.25C5.66739 19.25 1.74988 15.3325 1.74988 10.5C1.74988 5.66751 5.66739 1.75 10.4999 1.75C15.3324 1.75 19.2499 5.66751 19.2499 10.5ZM10.4999 15.5313C10.8623 15.5313 11.1561 15.2374 11.1561 14.875V9.625C11.1561 9.26256 10.8623 8.96875 10.4999 8.96875C10.1374 8.96875 9.84363 9.26256 9.84363 9.625V14.875C9.84363 15.2374 10.1374 15.5313 10.4999 15.5313ZM10.4999 6.125C10.9831 6.125 11.3749 6.51675 11.3749 7C11.3749 7.48325 10.9831 7.875 10.4999 7.875C10.0166 7.875 9.62488 7.48325 9.62488 7C9.62488 6.51675 10.0166 6.125 10.4999 6.125Z\" fill=\"black\"/>\n        </svg>";
          color = "black";
      }

      var dynamicDiv = document.createElement("div");
      dynamicDiv.innerHTML = "\n      <div class=\"flex items-center gap-2.5\">\n        <div class=\"p-2.5 bg-white/25 rounded-full flex items-center justify-center\">\n          <div class=\"w-6 h-6 flex items-center justify-center overflow-hidden\">" + icon + "</div>\n        </div>\n        <div class=\"flex flex-col gap-2.5\">\n          <p class=\"text-" + color + " text-sm font-medium\">" + title + "</p>\n          <p class=\"text-" + color + " text-xs font-normal\">" + subtitle + "</p>\n        </div>\n      </div>\n    ";

      (0, _toastifyJs2.default)({
        node: dynamicDiv,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        stopOnFocus: true,
        style: {
          background: bgColor,
          width: "328px",
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
          color: color
        }
      }).showToast();
    },
    cancelTopupWallet: function cancelTopupWallet() {
      this.topupWalletMode = false;
      this.topupAndPay = false;
      window.location.reload();
    },
    fetchCountries: async function fetchCountries() {
      var _this3 = this;

      await fetch("/iframev2/assets/json/countries.json").then(function (response) {
        return response.json();
      }).then(function (response) {
        _this3.countries = response.filter(function (country) {
          return country.code === "KE";
        });
        _this3.filteredCountries = response.filter(function (country) {
          return country.code === "KE";
        });
      }).catch(function (error) {
        _this3.countries = [];
        _this3.filteredCountries = [];
      }).finally(function () {});
    },
    openDialCodeMenu: function openDialCodeMenu() {
      this.dialCodeMenuOpen = true;
    },
    closeDialCodeMenu: function closeDialCodeMenu(divId) {
      var _this4 = this;

      var dialCodeDiv = document.getElementById(divId);
      if (!dialCodeDiv) return;
      document.addEventListener("click", function (event) {
        if (!dialCodeDiv.contains(event.target)) {
          _this4.dialCodeMenuOpen = false;
        }
      });
    },
    maskPhoneNumber: function maskPhoneNumber(tel) {
      return tel.replace(/(\d{4})\d+(\d{3})/, "$1******$2");
    },
    selectChannel: function selectChannel(channel) {
      this.selectedChannel = channel;
    },
    selectCountry: function selectCountry(value) {
      this.selectedCountry = value;
      this.dialCodeMenuOpen = false;
    },
    initiateStk: function initiateStk() {
      var fullPhoneNumber = (this.selectedCountryDialCode + this.phoneNumber).trim();

      switch (this.selectedChannel.label) {
        case "mpesa":
          this.initiateMpesaStkPush(fullPhoneNumber);
          break;
        case "airtel":
          this.initiateAirtelMoneyStkPush(fullPhoneNumber);
          break;
        case "tkash":
          this.initiateTKashStkPush(fullPhoneNumber);
          break;
        default:
      }
    },
    resendPaymentRequest: function resendPaymentRequest() {
      var fullPhoneNumber = (this.selectedCountryDialCode + this.phoneNumber).trim();
      this.currentStep -= 1;
      this.getStatusRetryCount = 0;
      switch (this.selectedChannel.label) {
        case "mpesa":
          this.initiateMpesaStkPush(fullPhoneNumber);
          break;
        case "airtel":
          this.initiateAirtelMoneyStkPush(fullPhoneNumber);
          break;
        case "tkash":
          this.initiateTKashStkPush(fullPhoneNumber);
          break;
        default:
      }
    },
    initiateMpesaStkPush: function initiateMpesaStkPush(msisdn) {
      var params = {};
      var url = "";
      if (this.topupWalletMode == false) {
        url = this.baseUrl + "/api/payment/mpesa/stk/" + this.requestType;
        params = {
          req_ref: this.invoice.invoice_number,
          gateway: this.selectedChannel.id,
          type: this.requestType,
          preferred_msisdn: msisdn
        };
        this.processRequest(url, params);
      }
    },
    initiateTKashStkPush: function initiateTKashStkPush(msisdn) {
      this.baseUrl = this.selectedChannel.configs.base_url;
      var params = {
        invoice_number: this.invoice.invoice_number,
        gateway_id: this.selectedChannel.id,
        amount: this.invoice.amount_expected,
        msisdn: msisdn
      };
      var url = this.baseUrl + "/api/payment/tkash/checkout";
      this.processRequest(url, params);
    },
    initiateAirtelMoneyStkPush: function initiateAirtelMoneyStkPush(msisdn) {
      this.baseUrl = this.selectedChannel.configs.base_url;
      var params = {
        invoice_number: this.invoice.invoice_number,
        gateway_id: this.selectedChannel.id,
        amount: this.invoice.amount_expected,
        msisdn: msisdn
      };
      var url = this.baseUrl + "/api/payment/airtel/checkout";
      this.processRequest(url, params);
    },
    processRequest: function processRequest(url, params) {
      var _this5 = this;

      Vue.axios.post(url, params, {
        headers: { Authorization: "" }
      }).then(function (response) {
        if (response.data.desc == "ok") {
          _this5.currentStep == 2 || _this5.currentStep == 3 ? _this5.currentStep = 2 : _this5.currentStep += 1;
        } else {
          _this5.showToastr("error", "STK PUSH ERROR", "Unable to send stk push, please try again.");
        }
      }).catch(function (error) {
        _this5.showToastr("error", "STK PUSH ERROR", "Please confirm the provided phone number and try again.");
      }).finally(function () {
        _this5.isLoading = false;
      });
    },
    confirmPayment: function confirmPayment() {
      var _this6 = this;

      this.isLoading = true;
      this.interValId = setInterval(function () {
        _this6.getPaymentStatus();
      }, 4000);
    },
    getPaymentStatus: function getPaymentStatus() {
      var _this7 = this;

      var params = {
        invoiceNumber: this.invoice.client_invoice_ref,
        gateway_id: this.selectedChannel.id,
        poll_external: true
      };

      if (this.topupWalletMode) {
        this.status_api_url = this.baseUrl + "/api/payment/co/getStatus";
      }

      Vue.axios.post(this.status_api_url, params).then(function (response) {
        if (response.data === "OK") {
          if (_this7.topupWalletMode && !_this7.topupAndPay) {
            window.location.reload();
          } else {
            _this7.currentStep = 4;
            window.top.location.href = _this7.callback_url;
          }
          clearInterval(_this7.interValId);
          _this7.isLoading = false;
        } else if (response.data === "CANCELLED") {
          clearInterval(_this7.interValId);
          Swal.fire({
            icon: "error",
            title: "Payment Info",
            text: "Payment was cancelled."
          });
        } else if (response.data === "PENDING") {
          if (_this7.getStatusRetryCount < _this7.getStatusMaxRetries) {
            _this7.getStatusRetryCount += 1;
          } else {
            clearInterval(_this7.interValId);
            _this7.isLoading = false;
            _this7.getStatusRetryCount = 0;
          }
        }
      }).catch(function (error) {}).finally(function () {});
    },
    redirectToMerchant: function redirectToMerchant() {
      if (this.callback_url != null && this.callback_url.length > 0) {
        window.top.location.href = this.callback_url;
      } else if (this.callback_url == null && this.invoice.status == "settled") {
        this.showToastr("success", "Payment Info", "Payment was successful.");
      }
    },
    validateByChannelType: function validateByChannelType(channel, phoneNumber) {
      if (this.telcos_prefixes[channel]) {
        return this.telcos_prefixes[channel].some(function (elem) {
          return phoneNumber.startsWith(elem.slice(3));
        });
      } else {
        false;
      }
    },
    validatePhoneNumberLength: function validatePhoneNumberLength(phoneNumber) {
      if (phoneNumber.length == 9) {
        return true;
      } else {
        return false;
      }
    },
    formatPhoneNumber: function formatPhoneNumber(phoneNumber) {
      if (!phoneNumber) return "";

      var cleaned = phoneNumber.replace(/[\s+]/g, "");

      if (cleaned.startsWith("254")) {
        cleaned = cleaned.substring(3);
      }

      if (cleaned.startsWith("0")) {
        cleaned = cleaned.substring(1);
      }

      return cleaned;
    },
    onSearchInput: function onSearchInput(event) {
      this.searchQuery = event.target.value;
    }
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.eventBus.$off("topup-wallet-clicked");
    _eventBus.eventBus.$off("topup-and-pay-wallet-clicked");
    _eventBus.eventBus.$off("cancel-topup-wallet-clicked");
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-span-10 h-full"},[(_vm.currentStep == 1 && _vm.availableChannels.length > 0)?_c('section',{staticClass:"mx-auto flex flex-col gap-6"},[_c('h4',{staticClass:"text-sm font-medium tracking-[1%] leading-[22px]"},[_vm._v("Mobile Money")]),_vm._v(" "),(_vm.topupWalletMode == true || _vm.variant === 'wallet')?_c('p',{class:_vm.variant === 'wallet' ? 'text-[15px] font-medium' : 'hidden md:block text-orange-500',style:(_vm.variant === 'wallet' ? 'color: #ef8e00' : '')},[_vm._v("\n      "+_vm._s(_vm.variant === 'wallet' ? 'Amount to top up:' : 'Amount to pay:')+"\n      "+_vm._s(_vm.topupAmount)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.variant === 'wallet' ? 'flex gap-4 w-full' : 'grid grid-cols-2 sm:grid-cols-3 gap-3 w-full',style:(_vm.variant !== 'wallet' ? 'flex-wrap: wrap' : '')},_vm._l((_vm.availableChannels),function(channel){return _c('div',{key:channel.label,staticClass:"flex items-center py-[6px] hover:bg-blue-100 transition-all cursor-pointer",class:{
          'px-[8px] min-w-[33%] max-w-[50%] rounded-[6px]': _vm.variant === 'wallet',
          'px-[12px] rounded-full lg:rounded-md': _vm.variant !== 'wallet',
          'border-[0.5px] border-[#006FFF] bg-[#EBF3FF]': _vm.selectedChannel && _vm.selectedChannel.label == channel.label,
          'bg-white border border-[#f5f5f5]': _vm.selectedChannel && _vm.selectedChannel.label != channel.label && _vm.variant === 'wallet',
          'bg-white border-none': _vm.selectedChannel && _vm.selectedChannel.label != channel.label && _vm.variant !== 'wallet',
        },on:{"click":function($event){return _vm.selectChannel(channel)}}},[(channel.label == 'mpesa')?_c('div',{staticClass:"flex items-center gap-2"},[_c('img',{staticClass:"h-7 w-7 rounded-full",attrs:{"src":"/iframev2/assets/img/png/mpesa.png","alt":"Mpesa logo"}}),_vm._v(" "),_c('p',{staticClass:"text-xs text-[#000007] font-medium m-0 normal-case"},[_vm._v("\n            "+_vm._s(channel.name)+"\n          ")])]):_vm._e(),_vm._v(" "),(channel.label == 'airtel')?_c('div',{staticClass:"flex items-center gap-2"},[_c('img',{staticClass:"h-7 w-7 rounded-full",attrs:{"src":"/iframev2/assets/img/png/airtel.png","alt":"Airtel logo"}}),_vm._v(" "),_c('p',{staticClass:"text-xs text-[#000007] font-medium tracking-[1%]"},[_vm._v("\n            "+_vm._s(channel.name)+"\n          ")])]):_vm._e(),_vm._v(" "),(channel.label == 'tkash')?_c('div',{staticClass:"flex items-center gap-2"},[_c('img',{staticClass:"h-7 w-7 rounded-full",attrs:{"src":"/iframev2/assets/img/png/tkash.png","alt":"Tkash logo"}}),_vm._v(" "),_c('p',{staticClass:"text-xs text-[#000007] font-medium tracking-[1%]"},[_vm._v("\n            "+_vm._s(channel.name)+"\n          ")])]):_vm._e()])}),0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200 text-sm text-primary-300 absolute",attrs:{"type":"hidden","placeholder":"0.00","disabled":""},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"flex flex-col gap-3 relative"},[(_vm.amountErr)?_c('div',{staticClass:"flex items-center"},[_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.amountErr))])]):_vm._e(),_vm._v(" "),(_vm.selectedChannel)?_c('div',{},[_c('label',{staticClass:"block text-sm font-medium leading-6 text-primary-300",attrs:{"for":"phone_number"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('div',{staticClass:"flex items-center mt-1 rounded-lg bg-white transition-colors duration-200",class:{
            'border border-[#4374F0] ring-1 ring-[#4374F0]/20': _vm.phoneInputFocused,
            'border border-[#D0D5DD]': !_vm.phoneInputFocused,
          }},[_c('div',{staticClass:"relative inline-block text-left max-w-[100px] h-full",attrs:{"id":"dial-code-menu"}},[_c('button',{staticClass:"flex justify-between items-center gap-2 text-sm font-semibold text-gray-900 hover:bg-gray-50 py-2 px-2 overflow-hidden",attrs:{"type":"button","id":"menu-button","aria-haspopup":"true"},on:{"click":function($event){return _vm.openDialCodeMenu()}}},[_c('div',{staticClass:"flex items-center gap-2"},[_c('span',{staticClass:"size-5 bg-cover bg-no-repeat bg-center text-sm"},[_vm._v(_vm._s(_vm.country != null ? _vm.country.emoji : ""))]),_vm._v(" "),_c('span',{staticClass:"truncate whitespace-nowrap text-[#667084] text-sm font-normal leading-normal"},[_vm._v(_vm._s(_vm.country != null ? _vm.country.dial_code : ""))])]),_vm._v(" "),_c('div',{staticClass:"size-5"},[_c('svg',{class:{
                    'duration-300 text-gray-400 rotate-180': _vm.dialCodeMenuOpen,
                  },attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M5 7.5L10 12.5L15 7.5","stroke":"#667085","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])])]),_vm._v(" "),(_vm.dialCodeMenuOpen)?_c('div',{staticClass:"absolute z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none min-w-60 overflow-hidden",attrs:{"role":"menu","aria-orientation":"vertical","aria-labelledby":"menu-button"}},[_c('div',{staticClass:"p-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200 text-sm text-primary-300",attrs:{"type":"text","placeholder":"Search countries by name or code..."},domProps:{"value":(_vm.searchQuery)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value},_vm.onSearchInput],"keyup":_vm.onSearchInput,"keydown":_vm.onSearchInput,"change":_vm.onSearchInput}})]),_vm._v(" "),_c('div',{staticClass:"overflow-x-auto mb-2 h-[300px] scrollbar divide-y divide-gray-100"},_vm._l((_vm.filteredCountries),function(country,index){return _c('div',{key:index},[_c('div',{staticClass:"w-full px-4 py-2 text-left flex gap-2 items-center text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer duration-300",on:{"click":function($event){return _vm.selectCountry(country)}}},[_c('span',{staticClass:"text-base rounded-full overflow-hidden"},[_vm._v(_vm._s(country.emoji))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(country.dial_code)+" "+_vm._s(country.name))])])])}),0)]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"flex-1 appearance-none !border-none !ring-0 bg-transparent px-3 py-2 text-sm font-['Inter'] focus:outline-none focus:ring-0",attrs:{"type":"tel","name":"phoneNumber","id":"phone_number","minlength":"9","maxlength":"9","placeholder":"700 000 000"},domProps:{"value":(_vm.phoneNumber)},on:{"focus":function($event){_vm.phoneInputFocused = true},"blur":function($event){_vm.phoneInputFocused = false},"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"flex items-center mt-2"},[_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.errorMessage))])])]):_vm._e()]),_vm._v(" "),(_vm.selectedChannel != null)?_c('div',{staticClass:"flex items-center gap-3",style:(_vm.variant !== 'wallet' ? 'color: red' : '')},[_c('button',{class:_vm.variant === 'wallet'
          ? 'w-full cursor-pointer bg-white border border-[#d0d5dd] text-[#344054] rounded-[8px] px-[14px] py-[8px] text-sm font-semibold shadow-sm'
          : 'w-full text-center btn-outline cursor-pointer',on:{"click":_vm.handleCancel}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),_c('button',{class:_vm.variant === 'wallet'
          ? 'w-full bg-[#0054a6] border border-[#0054a6] text-white rounded-[8px] px-[14px] py-[8px] text-sm font-semibold cursor-pointer shadow-sm disabled:opacity-50 disabled:cursor-not-allowed'
          : 'w-full btn-primary',attrs:{"disabled":!_vm.country || !_vm.phoneNumber || _vm.phoneNumber.length < 9 || _vm.amountError},on:{"click":function($event){return _vm.initiateStk()}}},[_vm._v("\n        "+_vm._s(_vm.variant === 'wallet' ? 'Top up' : 'Pay')+"\n      ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.currentStep == 2)?_c('section',{staticClass:"flex flex-col gap-4"},[_c('nav',{staticClass:"flex mb-4",attrs:{"aria-label":"Breadcrumb"}},[_c('ol',{staticClass:"flex items-center gap-4",attrs:{"role":"list"}},[_vm._m(0),_vm._v(" "),_c('li',[_c('div',{staticClass:"flex items-center gap-4"},[_c('svg',{staticClass:"h-5 w-5 flex-shrink-0 text-gray-400",attrs:{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true","data-slot":"icon"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z","clip-rule":"evenodd"}})]),_vm._v(" "),_c('a',{staticClass:"text-sm font-semibold text-[#0054A6] hover:text-blue-500",attrs:{"href":"#","aria-current":"page"}},[_vm._v(_vm._s(_vm.selectedChannel.name))])])])])]),_vm._v(" "),_c('div',{staticClass:"bg-[#FCFCFD] border border-[#D0D5DD] rounded-xl p-4 flex gap-3"},[_c('div',[_c('svg',{attrs:{"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 13.8332V10.4998M10 7.1665H10.0084M18.3334 10.4998C18.3334 15.1022 14.6024 18.8332 10 18.8332C5.39765 18.8332 1.66669 15.1022 1.66669 10.4998C1.66669 5.89746 5.39765 2.1665 10 2.1665C14.6024 2.1665 18.3334 5.89746 18.3334 10.4998Z","stroke":"#475467","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])]),_vm._v(" "),_c('div',{},[_c('h6',{staticClass:"text-primary-300 font-semibold text-sm mb-1"},[_vm._v("Notification sent to your phone")]),_vm._v(" "),_c('p',{staticClass:"text-sm text-primary-100 max-w-[439px] mb-3"},[_vm._v("\n          Hello, we have sent a payment notification to your registered phone number\n          "),_c('span',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.maskPhoneNumber(_vm.country.dial_code + _vm.phoneNumber)))])])])]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"py-5 sm:py-12 w-full flex items-center justify-center min-h-80"},[_c('img',{staticClass:"animate-spin w-24",attrs:{"src":"/iframev2/assets/img/png/loader.png","alt":"loader"}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.currentStep == 3)?_c('section',[_c('nav',{staticClass:"flex mb-4",attrs:{"aria-label":"Breadcrumb"}},[_c('ol',{staticClass:"flex items-center gap-2",attrs:{"role":"list"}},[_vm._m(1),_vm._v(" "),_c('li',[_c('div',{staticClass:"flex items-center gap-2"},[_c('svg',{staticClass:"h-5 w-5 flex-shrink-0 text-gray-400",attrs:{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true","data-slot":"icon"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z","clip-rule":"evenodd"}})]),_vm._v(" "),_c('a',{staticClass:"text-sm text-[#0054A6] hover:text-blue-500 capitalize font-bold",attrs:{"href":"#","aria-current":"page"}},[_vm._v(_vm._s(_vm.selectedChannel.label))])])])])]),_vm._v(" "),_c('div',{staticClass:"bg-[#FCFCFD] border border-[#D0D5DD] rounded-xl p-4 flex gap-3 mb-5"},[_c('div',{},[_c('button',{staticClass:"text-center btn-primary",attrs:{"href":"#","role":"button","disabled":_vm.isLoading},on:{"click":function($event){return _vm.resendPaymentRequest()}}},[_vm._v("\n          Resend STK\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"flex items-center gap-3"},[_c('button',{staticClass:"w-full text-center btn-outline cursor-pointer",attrs:{"type":"button"},on:{"click":function($event){_vm.currentStep = 1}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),_c('button',{staticClass:"w-full text-center btn-primary cursor-pointer",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){_vm.getStatusRetryCount = 0;
          _vm.confirmPayment();}}},[(!_vm.isLoading)?_c('span',[_vm._v("Confirm Payment")]):_c('span',[_vm._v("Confirming...")])])])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"hidden"},[_c('div',{staticClass:"mb-6 sm:mb-16"},[_c('nav',{staticClass:"flex",attrs:{"aria-label":"Breadcrumb"}},[_c('ol',{staticClass:"flex items-center gap-4",attrs:{"role":"list"}},[_vm._m(2),_vm._v(" "),_c('li',[_c('div',{staticClass:"flex items-center gap-4"},[_c('svg',{staticClass:"h-5 w-5 flex-shrink-0 text-gray-400",attrs:{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true","data-slot":"icon"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z","clip-rule":"evenodd"}})]),_vm._v(" "),_c('a',{staticClass:"text-sm font-semibold text-[#0054A6] hover:text-blue-500",attrs:{"href":"#","aria-current":"page"}},[_vm._v("Mpesa")])])])])])]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"flex flex-col items-center pt-6"},[_c('h2',{staticClass:"text-3xl text-gray-500 font-semibold leading-[38.68px] text-center mb-9 sm:mb-16"},[_vm._v("\n        Confirming payment\n      ")]),_vm._v(" "),_vm._m(3)]):_vm._e()]),_vm._v(" "),(_vm.currentStep == 4 || _vm.invoice.status == 'settled')?_c('section',[_c('div',{staticClass:"flex flex-col items-center w-full pt-6"},[_c('h2',{staticClass:"text-3xl text-gray-500 font-semibold leading-[38.68px] text-center"},[_vm._v("Transaction successful")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col items-center pb-4 max-w-[167px]"},[_vm._m(4),_vm._v(" "),_c('p',{staticClass:"text-center text-[#5d5d5d] text-2xl font-semibold font-['Inter'] leading-[29.01px]"},[_vm._v("\n          Your payment was successful\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn-blue w-full max-w-[194px] text-center mt-10 sm:mt-20",on:{"click":function($event){return _vm.redirectToMerchant()}}},[_vm._v("\n          Return\n        ")])])])]):_vm._e()])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"hover:text-primary-100 text-black text-sm font-medium leading-normal tracking-tight",attrs:{"href":"#"}},[_vm._v("Mobile Money")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"hover:text-primary-100 text-black text-sm font-medium leading-snug tracking-tight",attrs:{"href":"#"}},[_vm._v("Mobile Money")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"flex items-center gap-4"},[_c('a',{staticClass:"hover:text-primary-100 text-black text-sm font-medium leading-snug tracking-tight",attrs:{"href":"#"}},[_vm._v("Mobile Money")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center w-full py-4 min-h-80"},[_c('img',{staticClass:"animate-spin w-24",attrs:{"src":"/iframev2/assets/img/png/loader.png","alt":"Loader img"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"w-full",attrs:{"src":"/iframev2/assets/img/svg/checkmark.svg","alt":"Transaction successful img"}})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c53a4ffe", __vue__options__)
  } else {
    hotAPI.reload("data-v-c53a4ffe", __vue__options__)
  }
})()}